/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PreFillableFormTemplateTypeEnum {
    INDIVIDUAL = 'INDIVIDUAL',
    VEHICLE = 'VEHICLE',
}
